import { Component, OnInit } from '@angular/core';
import { ReportingService } from 'app/modules/reports/services/reporting.service';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { IExportColumnInfo, ITableColumns } from 'app/modules/reports/interfaces/reporting-data';
import { ICustomTableInfoExtend } from 'app/modules/shared/components/custom-mat-table/custom-mat-table.component';

@Component({
    selector: 'invoiced-loans',
    templateUrl: './invoiced-loans.component.html',
    styleUrls: ['./invoiced-loans.component.scss'],
})
export class InvoicedLoansComponent implements OnInit {
    constructor(private _reportService: ReportingService) {}

    searchTerm: string = '';
    columnInfoList: ITableColumns[];
    customTableInfo: ICustomTableInfoExtend;
    action: NoDataActionType;
    pageTitle: string;
    dateFilterSettings: any;
    selectedDate: Array<IInvoicedLoanDate>;
    dateArray: Array<IInvoicedLoanDate>;
    hideExcelExport = true;

    ngOnInit() {
        this.pageTitle = 'Invoiced Loans';
        this.searchTerm = '';
        this.action = NoDataActionType.pageStart;
        this.dateFilterSettings = {
            singleSelection: true,
            text: '',
            selectAllText: '',
            unSelectAllText: '',
            enableSearchFilter: false,
            classes: '',
            badgeShowLimit: 5,
            enableCheckAll: false,
            showCheckbox: false,
            labelKey: 'friendlyName',
            primaryKey: 'optionOrder',
            enableFilterSelectAll: false,
        };

        this.initializeTable();
        this.getDateFilters();
        this.getInvoiceData();
    }

    searchRows(event) {
        setTimeout(() => {
            this.action = NoDataActionType.search;
            this.searchTerm = event;
            if (this.customTableInfo.isDataReady) {
                this.customTableInfo = this._reportService.refreshCustomMatTable(
                    this.customTableInfo,
                    true,
                    true,
                    this.action
                );
            }
        }, 1000);
    }

    onDateFilterChange(event) {
        this.action = NoDataActionType.filter;
        this.selectedDate = [event];
        this.getInvoiceData();
    }

    getDateFilters() {
        let numberOfMonths = 20;
        this.dateArray = [];
        let date = new Date();
        let thisMonth = date.getMonth();
        let thisYear = date.getFullYear();

        for (let i = 0; i < numberOfMonths; i++) {
            let lastDayOfMonth = new Date(thisYear, thisMonth - i, 0);
            let startDateOfMonth = new Date(thisYear, thisMonth - i - 1, 1);
            this.dateArray.push({
                optionOrder: i.toString(),
                friendlyName: lastDayOfMonth.toLocaleDateString('en-US'),
                startDate: startDateOfMonth,
                endDate: lastDayOfMonth,
            });
        }
        this.selectedDate = [this.dateArray[0]];
    }

    initializeTable() {
        this.columnInfoList = [
            {
                fieldId: 'invoicedDate',
                fieldName: 'Invoice Date',
                fieldOrder: 0,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'date',
            },
            {
                fieldId: 'lienType',
                fieldName: 'Lien Type',
                fieldOrder: 1,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'string',
            },
            {
                fieldId: 'loanNumber',
                fieldName: 'Loan #',
                fieldOrder: 2,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'string',
                isHyperlink: false,
                aggregationType: 'count',
                hyperLinkTo_FieldId: 'loanNumber',
            },
            {
                fieldId: 'channel',
                fieldName: 'Channel',
                fieldOrder: 3,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'string',
            },
            {
                fieldId: 'completedDate',
                fieldName: 'Effective Date',
                fieldOrder: 4,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'date',
            },
            {
                fieldId: 'postedDate',
                fieldName: 'Posted as of Date',
                fieldOrder: 5,
                isSortable: true,
                headerAlignment: 'left',
                dataAlignment: 'left',
                width: 200,
                dataType: 'date',
            },
        ];

        this.customTableInfo = {
            tableId: 'file-upload-table',
            tableHeight: 500,
            hasData: false,
            isDataReady: false,
            columnInfoList: this.columnInfoList,
            dataSet: [],
            searchTerm: this.searchTerm,
            action: NoDataActionType.pageStart,
            title: this.pageTitle,
            bandColorList: [],
            dataHandleInUiSide: true,
            showSummary: true,
        };
    }

    getInvoiceData() {
        let currentDateFilter = this.selectedDate[0];
        let customTableInfo = Object.assign({}, this.customTableInfo);
        customTableInfo.hasData = false;
        customTableInfo.isDataReady = false;
        customTableInfo.dataSet = [];
        this.hideExcelExport = false;
        this.customTableInfo = this._reportService.refreshCustomMatTable(
            customTableInfo,
            false,
            false,
            this.action
        );
        this._reportService
            .getInvoiceData(currentDateFilter.startDate, currentDateFilter.endDate)
            .subscribe({
                next: (res) => {
                    customTableInfo.dataSet = res;
                    let hasData = res && res.length > 0;
                    this.hideExcelExport = !hasData;
                    this.customTableInfo = this._reportService.refreshCustomMatTable(
                        customTableInfo,
                        hasData ?? false,
                        true,
                        this.action
                    );
                },
                error: (err) => {
                    this.customTableInfo = this._reportService.refreshCustomMatTable(
                        customTableInfo,
                        false,
                        true,
                        NoDataActionType.error
                    );
                },
            });
    }

    exportToExcel() {
        // let exportName = 'Invoiced-loans-';
        // let columnInfoArray: IExportColumnInfo[] = [];

        this._reportService.setExportColumnsAndExportToExcel(
            this.columnInfoList,
            this.customTableInfo.dataSet,
            'Invoiced-loans-'
        );

        // this.customTableInfo.columnInfoList.forEach((column, index) => {
        //     if (!column.excludeOnExport) {
        //         columnInfoArray.push({
        //             columnId: index,
        //             columnName: column.fieldName,
        //             columnIdName: column.fieldId,
        //             precision: 0,
        //             dataType: column.dataType as any,
        //         });
        //     }
        // });
        //
        // this._reportService.setQuickExportData(
        //     columnInfoArray,
        //     this.customTableInfo.dataSet,
        //     exportName,
        //     false
        // );
    }
}

export interface IInvoicedLoanDate {
    friendlyName: string;
    optionOrder: string;
    startDate: Date;
    endDate: Date;
}
